import { render, staticRenderFns } from "./ImageList.vue?vue&type=template&id=87126d4c&scoped=true&"
import script from "./ImageList.vue?vue&type=script&lang=js&"
export * from "./ImageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87126d4c",
  null
  
)

export default component.exports